module.exports = __webpack_public_path__ + "media/Cogneetiv-Ping-AI-2.4c223cf3.wav";